import * as d3 from "d3";

import { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import ComboBox from '../../components/ComboBox';

import { GraphContext } from "../GraphContext";
import "../../styles.css";

import dayjs from 'dayjs';
import { saveAs } from 'file-saver';

import { preferences } from "../../preferences";

import { getCurrentYear, } from '../../js/datetime';
import { getBorders, getHeight, dateToYMD } from '../../components/d3/multiplegraphs';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

import ExcelButton from '../../components/ExcelButton';
import GraphicButton from '../../components/GraphicButton';
import InfoButton from '../../components/InfoButton';
import DatePicker from '../../components/DatePicker';

import { borders, addLine, addArea } from '../../components/d3/legend/legend';
import { xlabel, ylabel, logo } from '../../components/d3/charts/chart';
import { timeformat, getWidth, responsivness } from '../../components/d3/d3timeformat';

import { useMatomo } from '@datapunt/matomo-tracker-react'


export const Soil = ({ description, list }) => {

    const { trackPageView, trackEvent } = useMatomo()
    const { t, i18n } = useTranslation();

    const location = useLocation();

    const [parameter] = useContext(GraphContext);

    const [fromdjs, setFromdjs] = useState(dayjs());

    const [year, setYear] = useState(dayjs().year());
    const [id, setId] = useState(22);

    const svgRef = useRef();

    const [data, setData] = useState({});
    const [phyllo, setPhyllo] = useState([]);

    const [resize, setResize] = useState(getWidth());
    const resizeHandler = (() => {
        setResize(getWidth());
    });


    const ids = [22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33];

    window.addEventListener('resize', resizeHandler);

    const Item = styled(Paper)(({ theme }) => ({

        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));

    useEffect(() => {

        d3.json(preferences.address + "/query/wineculture/fyllo/get.php?station=" + parameter.station + "&year=" + year) // "&year=" + year
            .then((d) => {
                setData(d);
            });
    }, [parameter, year]);

    // Track page view
    useEffect(() => {
        trackPageView({
            documentTitle: 'Fyllo', // optional                                                                       
            href: 'https://meteo.laimburg.it' + location.pathname, // optional
            customDimensions: [
                {
                    id: 1
                },
            ], // optional
        })
    }, [trackPageView, location])


    useEffect(() => {

        const svg = d3.select(svgRef.current);
       

        if (data.liste !== undefined)
            draw(svg);

        //let r = responsivness();
        /*if (r.dialog) {
            let labels = [t("temperature_mids"), t("temperature_maps"), t("above_middle"), t("underneath_middle")]
            borders(svg, labels, 300, 70, 10);
            addLine(svg, 0, 2.5, "black", labels[0]);
            addLine(svg, 1, 1.5, "black", labels[1]);
            addArea(svg, 2, "red", labels[2]);
            addArea(svg, 3, "blue", labels[3]);
        }*/

    }, [resize, data, i18n.language, phyllo]);


    /*useEffect(() => {
        let list = [];
        d3.csv("/phyllo/logger.csv", function (data) {
            list.push(data)
        });
        setPhyllo(list);
    }, [year]);*/

    useEffect(() => {

        /*d3.json("https://fylloclip.altervista.org/fyllo_to_meteo.php?ID=" + id + "&year=" + year) // "&year=" + year
        .then((d) => {
            setPhyllo(list);
        });*/

        fetch("https://tensiometer.altervista.org/tensio_to_meteo.php?year=" + year, {
            method: 'GET',
            mode: 'cors',
            cache: "no-cache",
            headers: {/*'Access-Control-Allow-Origin' ;*/}
        })
            .then(response => response)
            .then(response => response.json())
            .then((data) => {
                setPhyllo(data);
            });
        
    }, [id, year]);


    const downloadExcel = () => {

        var url = preferences.address + '/query/climate/temperature/overview/excel.php';

        let block = {};
        block.station = parameter.station;
        block.year = year;
        block.lang = i18n.language;

        let filename = ''
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: "no-cache",
            headers: {
            },
            body: JSON.stringify(block)
        })
            .then((response) => {
                try { filename = response.headers.get('content-disposition').split('filename=')[1]; }
                catch (error) { filename = 'Data_Export.xlsx' }
                return response.blob()
            })
            .then((data) => {
                var file = new File([data], filename, { type: "application/vnd.ms-excel;charset=utf-8" })
                saveAs(file);
                trackEvent({
                    category: 'Downloads',
                    action: 'Excel',
                    name: filename, // optional
                    href: 'https://meteo.laimburg.it' + location.pathname, // optional	    
                })
            });


    }


    const handleSelector = (event) => {

        setFromdjs(event);
        let date = event.$d;
        setYear(1900 + date.getYear());
    }

    const handleChangeID = (event) => {
        let id = ids[event.target.value-1];
        //console.log (id)
        setId (event.target.value);
    }


    var xScaleTime;
    var xScaleBand;
    let brush;
    let xAxis;
    let xGrid;
    let clip;

    let yScale;
    let yScaleN;
    let yScaleS;

    let yScaleTensio;

    var width = 0;
    var margin = { top: 10, right: 100, bottom: 40, left: 100, bottomHeight: 100, offset: 40, graphs: [200, 300, 100, 100] }

    var height = getHeight(margin); //1000;// - margin.top - margin.bottom;

    var min;
    var max;

    function draw(svg) {

        // Import time format
        timeformat(t);

        // Clear
        svg.selectAll("*").remove();

        // setup SVG
        svg
            .attr("viewBox", [0, 0, svg.style('width'), svg.style('height')])
            .style("overflow", "visible")
            .style("-webkit-tap-highlight-color", "transparent")
            .on("pointerenter pointermove", pointermoved)
            .on("pointerleave", pointerleft)
            .on("touchstart", event => event.preventDefault());

        // Getting width
        width = parseInt(svg.style('width'));

        // Add Y axis
        min = d3.min([d3.min(data.liste, (d) => { return + d.actual; }), -10]);
        max = d3.max([d3.max(data.liste, (d) => { return + d.actual; }), 30]);

        // SVG
        svg
            .attr("width", width) // + margin.left + margin.right
            .attr("height", height)
        //.append("g")
        //.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        // Add X axis --> it is a date format
        xScaleTime = d3.scaleTime()
            .domain([d3.timeParse("%Y-%m-%d")(year + "-01-01"), d3.timeParse("%Y-%m-%d")((year) + "-12-31")])
            .range([margin.left, width - margin.right])

        let dates = d3.map(data.liste, d => d3.timeParse("%Y-%m-%d")(d.date));


        let filtered = dates.filter((d) => { return (d.getYear() + 1900) === year });
        //let filtered = dates.filter((d) => { return (dateToYMD(d) >= "2024-07-28" && dateToYMD(d) <= "2024-10-20") });


        xScaleBand = d3.scaleBand()
            .domain(filtered)
            .range([margin.left, width - margin.right]).padding(0);


        // Y grid
        yScale = d3.scaleLinear()
            .domain([min, max])
            //.range([height - margin.bottom - margin.bottomHeight - margin.offset - 400, margin.top]);
            .range(getBorders(margin, 0));

        yScaleTensio = d3.scaleLinear()
            //.domain([d3.min(phyllo.map((d) => parseInt(d.A))), d3.max(phyllo.map((d) => parseInt(d.A)))]) // 0, 100
            .domain([0, 600]) // 0, 100
            .range(getBorders(margin, 1));

      // Y under
        yScaleN = d3.scaleLinear()
            .domain([0, 100])
            //.range([height - margin.bottom, height - margin.bottom - margin.bottomHeight]);
            .range(getBorders(margin, 2));
        // Y under
        yScaleS = d3.scaleLinear()
            .domain([0, 100])
            //.range([height - margin.bottom, height - margin.bottom - margin.bottomHeight]);
            .range(getBorders(margin, 3));

        //console.log (d3.min(phyllo.map((d) => parseInt(d.A))), d3.max(phyllo.map((d) => parseInt(d.A))));
        //console.log(phyllo);
        // Y under


        // brush
        brush = d3.brushX()
            .extent([[margin.left, 0], [width - margin.right, height - margin.bottom]])
            .on("end", updateChart); // brushended

        svg.append("g")
            .attr('class', 'brush')
            .call(brush);

        // Clip
        clip = svg.append('g')
            .attr("clip-path", "url(#clip)");

        svg.append("defs")
            .append("svg:clipPath")
            .attr('id', 'clip')
            .append("svg:rect")
            .attr("x", margin.left)
            .attr("y", 0)
            .attr("width", width - margin.left - margin.right)
            .attr("height", height);


        let grid = svg.append("g").attr("id", "grid")

        // Vertical grid
        let bottomScale = d3.axisBottom(xScaleTime);
        xGrid = grid.append("g")
            .attr('id', 'xgrid')
            .attr('transform', 'translate(0 ,' + (height - margin.bottom) + ')')
            .style("pointer-events", "none")
            .attr("stroke-width", 1)
            .attr("stroke", "black")
            .attr("opacity", 0.3)
            .call(bottomScale.tickSize(-height + margin.bottom + margin.top, 0).tickFormat(""));

        // Horizontale ticks temperature
        // H grid temperature
        let axisLeft = d3.axisLeft(yScale);
        grid.append("g")
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .style("pointer-events", "none")
            .attr("stroke-width", 1)
            .attr("stroke", "black")
            .attr("opacity", 0.3)
            .call(axisLeft.tickSize(-width + margin.left + margin.right, 0).tickFormat(""));

        // Horizontale ticks Regen
        // H grid Niederschlag
        let axisLeftN = d3.axisLeft(yScaleN);
        clip.append("g") //grid
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .style("pointer-events", "none")
            //.attr("class", "gridline")
            .attr("stroke-width", 1)
            .attr("stroke", "#000000")
            .attr("opacity", 0.3)
            .call(axisLeftN.tickSize(-width + margin.left + margin.right, 0).tickFormat(""));

        let axisLeftS = d3.axisLeft(yScaleS);
        clip.append("g") //grid
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .style("pointer-events", "none")
            //.attr("class", "gridline")
            .attr("stroke-width", 1)
            .attr("stroke", "#000000")
            .attr("opacity", 0.3)
            .call(axisLeftS.tickSize(-width + margin.left + margin.right, 0).tickFormat(""));

        let axisLeftTensio = d3.axisLeft(yScaleTensio);
        clip.append("g") //grid
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .style("pointer-events", "none")
            //.attr("class", "gridline")
            .attr("stroke-width", 1)
            .attr("stroke", "#000000")
            .attr("opacity", 0.3)
            .call(axisLeftTensio.tickSize(-width + margin.left + margin.right, 0).tickFormat(""));

    

        // Axis
        let axis = svg.append("g").attr("id", "axis")
        /* X axis rain */
        xAxis = svg.append("g")
            .attr("transform", "translate(0," + (height - margin.bottom) + ")")
            .attr("class", "axes")
            .call(d3.axisBottom(xScaleTime).ticks(width / 80 > 12 ? 12 : width / 80))
            .style("font-size", "12px");

        // Y Achse Temperatur
        axis.append("g")
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .attr("class", "axes")
            .call(axisLeft.ticks(10, "0.1f").tickFormat((x) => { return x + " °C" }).tickSize(5))
            .style("font-size", "12px");

        // y Achse Niederschlag
        axis.append("g")
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .attr("class", "axes")
            .call(axisLeftN.ticks(4, "0f").tickFormat((x) => { return x + " mm" }).tickSize(5))
            .style("font-size", "12px");

        axis.append("g")
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .attr("class", "axes")
            .call(axisLeftS.ticks(4, "0f").tickFormat((x) => { return x + " w/m²" }).tickSize(5))
            .style("font-size", "12px");

        // LEFT
        axis.append("g")
            .attr('transform', 'translate(' + margin.left + ' ,0)')
            .attr("class", "axes")
            .call(axisLeftTensio.ticks(4, "0f").tickFormat((x) => { return x + ' Pa' }).tickSize(5))
            .style("font-size", "12px");
     

        // Add the lines group
        const lines = clip
            .append("g")
            .attr('id', 'lines');


        //const X = d3.map(data, (d) => { return d3.timeParse("%Y-%m-%d")(d.date) });
        const Y1 = d3.map(data.liste, (d) => { return d.longterm });
        //const Y2 = d3.map(data, (d) => { return d.longterm });
        //const I = d3.range(data.length);
        //const defined = (d, i) => Y1[i];
        //const D = d3.map(data, defined);
        //const line = (y) => d3.line().defined(i => D[i]).curve(d3.curveLinear).x(i => xScale(X[i])).y(y)(I);
        //const area = (y0, y1) => d3.area().defined(i => D[i]).curve(d3.curveLinear).x(i => xScale(X[i])).y0(y0).y1(y1)(I);

        //.attr("x", function (d) { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScaleBand(ld) })

        lines.append("path")
            .datum(data.liste)
            .attr('id', 'path1')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", "grey")
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y((d, i) => { return yScale(d.longterm) })
                .defined(((d) => { return d.longterm !== null; }))
            );

        // Add zero line
        lines.append("line")
            .attr('id', 'zeroLine')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", "black")
            .attr("stroke-width", 1.0)
            .attr("x1", margin.left)
            .attr("y1", yScale(0))
            .attr("x2", width - margin.right)
            .attr("y2", yScale(0));

        lines.append("path")
            .datum(data.liste)
            .attr('id', 'path2')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", "black")
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d, i) => { return yScale(d.actual) })
                .defined(((d) => { return d.actual !== null; }))
            );


        const box = clip
            .append("g");

        // Striped up
        /*box.selectAll(".bar")
            .data(data.liste)
            .enter()
            .append("rect")
            .attr("class", "bar2")
            .style("pointer-events", "none")
            //.attr("x", function (d) { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScaleBand(ld) })
            .attr("x", function (d) { return xScaleBand(d3.timeParse("%Y-%m-%d")(d.date)) })
            .attr("y", margin.top)
            .attr("width", (d) => { return xScaleBand.bandwidth() })
            .attr('fill', function (d) { return (d.rain === null ? '#084594' : '#084594') })
            .attr('opacity', function (d) { return (d.rain === null ? 0 : d.rain / 100) })
            .attr("height", height - margin.bottom - margin.bottomHeight - margin.offset - margin.top);*/

        // Striped down
        box.selectAll(".bar")
            .data(data.liste)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .style("pointer-events", "none")
            .attr("x", function (d) { return xScaleBand(d3.timeParse("%Y-%m-%d")(d.date)) })
            .attr("y", (d) => { return yScaleN(d.rain) })
            .attr("width", (d) => { return xScaleBand.bandwidth() })
            .attr("height", (d) => { return yScaleN(0) - yScaleN(d.rain) })
            .attr('fill', '#084594');

        const box2 = clip
            .append("g")
            .attr('id', 'box2');
        box2.selectAll(".bar")
            .data(data.liste)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .style("pointer-events", "none")
            .attr("x", function (d) { return xScaleBand(d3.timeParse("%Y-%m-%d")(d.date)) })
            .attr("y", (d) => { return yScaleS(d.radiaton === null ? 0 : d.radiation / 10) + height - margin.bottom - yScaleS(0) })
            .attr("width", (d) => { return xScaleBand.bandwidth() })
            .attr("height", (d) => { return yScaleS(0) - yScaleS(d.radiaton === null ? 0 : d.radiation / 10) })
            .attr('fill', 'orange')
            .attr('opacity', 0.5)
            .filter((d) => { return d.radiation !== null });


        // Cursor line
        svg.append('line')
            .attr('id', 'cursorLine')
            .attr('stroke', 'grey')
            .attr('display', null);


        // Tensio tensio_20cm":97,"tensio_40cm":205,"tensio_60cm":144,"tensio_80cm":211,"gw":
        lines.append("path")
            .datum(phyllo)
            .attr('id', 'tensio20')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", d3.schemeCategory10[0])
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                .y((d, i) => { return yScaleTensio(d.tensio_20cm) })
                .defined(((d) => { return d.tensio_20cm !== null; }))
            );
        lines.append("path")
            .datum(phyllo)
            .attr('id', 'tensio40')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", d3.schemeCategory10[1])
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                .y((d, i) => { return yScaleTensio(d.tensio_40cm) })
                .defined(((d) => { return d.tensio_40cm !== null; }))
            );
        lines.append("path")
            .datum(phyllo)
            .attr('id', 'tensio60')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", d3.schemeCategory10[2])
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                .y((d, i) => { return yScaleTensio(d.tensio_60cm) })
                .defined(((d) => { return d.tensio_60cm !== null; }))
            );
        lines.append("path")
            .datum(phyllo)
            .attr('id', 'tensio80')
            .attr('class', "line")
            .attr("fill", "none")
            .attr("stroke", d3.schemeCategory10[3])
            .attr("stroke-width", 1.5)
            .attr("d", d3.line()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                .y((d, i) => { return yScaleTensio(d.tensio_80cm) })
                .defined(((d) => { return d.tensio_80cm !== null; }))
            );
       
       


        var dotgroup = svg.append("g").attr('id', 'dotgroup');

        /*  actual */
        dotgroup.append("circle")
            .attr('id', 'dot1')
            .style('display', 'none')
            .style("stroke", "grey")
            .style("fill", 'black')
            .attr("r", 3);
        dotgroup.append("circle")
            .attr('id', 'dot2')
            .style('display', 'none')
            .style("stroke", "grey")
            .style("fill", 'black')
            .attr("r", 3);
        dotgroup.append("circle")
            .attr('id', 'dot3')
            .style('display', 'none')
            .style("stroke", "grey")
            .style("fill", 'black')
            .attr("r", 3);
        dotgroup.append("circle")
            .attr('id', 'dot4')
            .style('display', 'none')
            .style("stroke", "grey")
            .style("fill", 'black')
            .attr("r", 3);


        createArea();

        var tooltip = svg.append("g")
            .attr('id', 'tooltip')
            .style("pointer-events", "none");

        tooltip.append("path")
            .attr('id', 'pathtool')
            .data([,])
            .attr("class", "shadow")
            .attr("fill", "white")
            .attr("stroke", 'black')
            .attr("stroke-width", 1.5)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round");

        var tooltiptext = tooltip.append("text")
            .attr('id', 'tooltiptext')
            .style("pointer-events", "none");

        // Date
        tooltiptext
            .append("tspan")
            .attr('id', 'date')
            .attr("x", 15)
            .attr("y", 0)
            .attr('text-anchor', 'start')
            .attr('font-size', 'smaller');

        tooltiptext
            .append("tspan")
            .attr('id', 'value1')
            .attr("x", 25)
            .attr("y", 20)
            .attr("stroke", 'black')
            .attr('text-anchor', 'start')
            .attr('font-size', 'smaller');

        tooltiptext
            .append("tspan")
            .attr('id', 'value2')
            .attr("x", 25)
            .attr("y", 40)
            .attr("stroke", 'black')
            .attr('text-anchor', 'start')
            .attr('font-size', 'smaller');
        tooltiptext
            .append("tspan")
            .attr('id', 'value3')
            .attr("x", 25)
            .attr("y", 60)
            .attr("stroke", 'black')
            .attr('text-anchor', 'start')
            .attr('font-size', 'smaller');
        tooltiptext
            .append("tspan")
            .attr('id', 'value4')
            .attr("x", 25)
            .attr("y", 80)
            .attr("stroke", 'black')
            .attr('text-anchor', 'start')
            .attr('font-size', 'smaller');

        // Delta
        /*xlabel(svg, "Delta: " + data.delta + " °C", width - 80, 30);
        const colorFn = d3.scaleLinear()
            .domain([-2, 0, 2])
            .range(['royalblue', 'white', 'red'])
            .interpolate(d3.interpolateCubehelix);
        svg.append("rect")
            .attr("x", width - 120)
            .attr("y", 40)
            .attr("rx", 1)
            .attr("ry", 1)
            .attr("fill", colorFn(data.delta))
            .attr("stroke", "black")
            .attr("stroke-width", 2)
            .attr("height", 20)
            .attr("width", 90);*/

        xlabel(svg, t("year"), width / 2, height - 5);

        ylabel(svg, t("temperature"), - height * 0.15, 15);
        
        ylabel(svg, t("soilhumidity"), - height * 0.4, 15);

        ylabel(svg, t("rain"), - height * 0.74, 15);
        ylabel(svg, t("globalrad"), - height * 0.9, 15);

        // Image
        logo(svg);

    }

    function createArea() {
        //const svg = d3.select(svgRef.current);

        //const X = d3.map(data, (d) => { return d3.timeParse("%Y-%m-%d")(d.date) });
        const Y1 = d3.map(data.liste, (d) => { return d.actual });
        //const Y2 = d3.map(data, (d) => { return d.longterm });
        //const I = d3.range(data.length);

        const defined = (d, i) => { return Y1[i] != null };

        // Obere Fläche
        clip.append('clipPath')
            .datum(data.liste.filter(defined))
            .attr('id', 'clippath_up')
            .append('path')
            .attr('id', 'clippath_up_path')
            .attr("d", d3.area()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(d.longterm) })
                .y1(function (d) { return yScale(max) })
                .defined((d) => d.longterm !== null)
            );

        // Obere Fläche
        clip.append("path")
            .datum(data.liste.filter(defined))
            .attr('clip-path', "url(#clippath_up)")
            .attr('class', 'area1')
            .attr("fill", "red")
            .attr('opacity', 0.5)
            .attr("stroke-width", 0)
            .attr("d", d3.area()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(d.actual) })
                .y1(function (d) { return yScale(min) })
                .defined((d) => d.actual !== null)
            )

        // Untere Fläche schneiden
        clip.append('clipPath')
            .datum(data.liste.filter(defined))
            .attr('id', 'clippath_down')
            .append('path')
            .attr('id', 'clippath_down_path')
            .attr("d", d3.area()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(min) })
                .y1(function (d) { return yScale(d.longterm) })
                .defined((d) => d.longterm !== null)
            );

        clip.append("path")
            .datum(data.liste.filter(defined))
            .attr('clip-path', "url(#clippath_down)")
            .attr('class', 'area2')
            .attr("fill", "blue")
            .attr('opacity', 0.5)
            .attr("stroke", "#69b3a2")
            .attr("stroke-width", 0)
            .attr("d", d3.area()
                .x((d, i) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(d.actual) })
                .y1(function (d) { return yScale(max) })
                .defined((d) => d.actual !== null)
            )
    }


    function pointermoved(event) {

        const X = d3.map(phyllo, d => d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp));
        const I = d3.map(phyllo, (_, i) => i);
        const i = d3.bisectCenter(X, xScaleTime.invert(d3.pointer(event)[0] - 5));

        // cursorline
        const svg = d3.select(svgRef.current);
        svg.selectAll('#cursorLine')
            .style('display', null)
            .attr('x1', d3.pointer(event)[0] - 5)
            .attr('x2', d3.pointer(event)[0] - 5)
            .attr('y1', margin.top)
            .attr('y2', height - margin.bottom);

        svg
            .selectAll('#dot1')
            .style('display', null)
            .attr("cx", d3.pointer(event)[0] - 5)
            .attr("cy", + yScaleTensio(i > 0 ? phyllo[i].tensio_20cm : 0));
        svg
            .selectAll('#dot2')
            .style('display', null)
            .attr("cx", d3.pointer(event)[0] - 5)
            .attr("cy", + yScaleTensio(i > 0 ? phyllo[i].tensio_40cm : 0));
        svg
            .selectAll('#dot3')
            .style('display', null)
            .attr("cx", d3.pointer(event)[0] - 5)
            .attr("cy", + yScaleTensio(i > 0 ? phyllo[i].tensio_60cm : 0));
        svg
            .selectAll('#dot4')
            .style('display', null)
            .attr("cx", d3.pointer(event)[0] - 5)
            .attr("cy", + yScaleTensio(i > 0 ? phyllo[i].tensio_80cm : 0));

        // Textbox with values
        var tooltiptext = svg.select("#tooltiptext");
        tooltiptext.attr("transform", `translate(${0}, ${30 - 0})`); // Text

        const { x, y, width: w, height: h } = tooltiptext.node().getBBox();

        var path = svg.select("#pathtool");

        if (xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(phyllo[i].date)) === width - margin.right) {
            svg.select("#tooltip").style("display", 'none');
        }

        let rb = xScaleTime(X[i]) > width - 100 ? width - 100 : xScaleTime(X[i]);
        svg.select("#tooltip")
            .style("display", null)
            .attr("text-anchor", "middle")
            .attr("transform", `translate(${rb},0)`);

        path
            .style('display', null)
            .transition()
            .duration(100)
            .attr('d', `M 0 20 l 10 -10 H${20 + w} V${25 + h} H10 V25 Z`);

        svg.select("#date")
            .transition()
            .duration(200)
            .text(phyllo[i].timestamp);

        svg.select("#value1")
            .transition()
            .duration(200)
            .text("20cm: " + phyllo[I[i]].tensio_20cm + " Pa");
        svg.select("#value2")
            .transition()
            .duration(200)
            .text("40cm: " + phyllo[I[i]].tensio_40cm + " Pa");
        svg.select("#value3")
            .transition()
            .duration(200)
            .text("60cm: " + phyllo[I[i]].tensio_60cm + " Pa");
        svg.select("#value4")
            .transition()
            .duration(200)
            .text("80cm: " + phyllo[I[i]].tensio_80cm + " Pa");



        let x_pos = d3.pointer(event)[0];

        if (x_pos < 400) {
            svg.selectAll('#legend').attr('opacity', 0.1)
        }
        else {
            svg.selectAll('#legend').attr('opacity', 1)
        }

        if (data.liste[I[i]].actual === null) {
            svg.select("#tooltip").style("display", 'none');
            svg.select("#dot1").style("display", 'none');
            svg.select("#dot2").style("display", 'none');
        }
        else {
            svg.select("#tooltip").style("display", null);
        }

    }

    function pointerleft() {
        const svg = d3.select(svgRef.current);

        svg.selectAll('#cursorLine')
            .style('display', 'none');

        svg
            .selectAll('#dot1')
            .style('display', 'none')

        svg.select("#tooltip")
            .style("display", 'none');

        svg.selectAll('#legend').attr('opacity', 1)
    }

    var idleTimeout
    function idled() { idleTimeout = null; }



    function updateChart(event) {

        const svg = d3.select(svgRef.current);

        var extentX = event.selection
        var t1;

        if (!extentX) {

            if (!idleTimeout) return idleTimeout = setTimeout(idled, 350); // waiting a bit

            //var min = d3.min(data, (d) => { return d.date })
            //var max = d3.max(data, (d) => { return d.date })

            let dates = d3.map(data.liste, d => d3.timeParse("%Y-%m-%d")(d.date));
            let filtered = dates.filter((d) => { return (d.getYear() + 1900) === year });
            //let filtered = dates.filter((d) => { return (dateToYMD(d) >= "2024-07-28" && dateToYMD(d) <= "2024-10-20") });

            xScaleTime// = d3.scaleTime()
                .domain([d3.timeParse("%Y-%m-%d")(year + "-01-01"), d3.timeParse("%Y-%m-%d")((year+1) + "-01-01")]);

            xScaleBand
                .domain(filtered)
        }
        else {
            var from = xScaleTime.invert(extentX[0]);
            from.setHours(0);
            from.setMinutes(0);
            from.setSeconds(0);
            var to = xScaleTime.invert(extentX[1]);
            to.setHours(0);
            to.setMinutes(0);
            to.setSeconds(0);
            //console.log(xScale.invert(extentX[0]), xScale.invert(extentX[1]));

            xScaleTime.domain([from, to]);

            var t = d3.map(data.liste, d => d3.timeParse("%Y-%m-%d")(d.date));
            t1 = t.filter(item => item >= from && item <= to);
            t1.forEach((d) => { d.setDate(d.getDate() - 1) });
            xScaleBand.domain(t1);

            // This remove the grey brush area as soon as the selection has been done
            svg.select(".brush").call(brush.move, null)

        }


        // Bottom
        xAxis.transition()
            .duration(1000)
            .call(d3.axisBottom(xScaleTime));

        // Bottom grid
        xGrid.transition()
            .duration(1000)
            .call(d3.axisBottom(xScaleTime).tickSize(- height + margin.top + margin.bottom, 0).tickFormat(""));

        // Linie längjähriges Mittel
        svg.selectAll("#path1")
            .transition()
            .duration(1000)
            .attr("d", d3.line()
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d) => { return yScale(d.longterm) })
                .defined(((d) => { return d.longterm !== null; })));

        // Linie ausgewähltes Jahr
        svg.selectAll("#path2")
            .transition()
            .duration(1000)
            .attr("d", d3.line()
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d) => { return yScale(d.actual) }));

        // Tensio 20 cm
        svg.selectAll("#tensio20")
            .transition()
            .duration(1000)
            .attr("d", d3.line()
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d) => { return yScaleTensio(d.tensio_20cm) }));
        // Tensio 40 cm
        svg.selectAll("#tensio40")
            .transition()
            .duration(1000)
            .attr("d", d3.line()
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d) => { return yScaleTensio(d.tensio_40cm) }));
        // Tensio 60 cm
        svg.selectAll("#tensio60")
            .transition()
            .duration(1000)
            .attr("d", d3.line()
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d) => { return yScaleTensio(d.tensio_60cm) }));
        // Tensio 80 cm
        svg.selectAll("#tensio80")
            .transition()
            .duration(1000)
            .attr("d", d3.line()
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d %H:%M:%S")(d.timestamp)) })
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .y((d) => { return yScaleTensio(d.tensio_80cm) }));

    
        // Probe
        svg.selectAll("#clippath_up_path")
            .transition()
            .duration(1000)
            .attr("d", d3.area()
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(d.longterm) })
                .y1(function (d) { return yScale(max) })
            );

        svg.selectAll(".area1")
            .transition()
            .duration(1000)
            .attr("d", d3.area()
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(min) })
                .y1(function (d) { return yScale(d.actual) })
            )
        svg.selectAll("#clippath_down_path")
            .transition()
            .duration(1000)
            .attr("d", d3.area()
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(max) })
                .y1(function (d) { return yScale(d.actual) })
            );
        svg.selectAll(".area2")
            .transition()
            .duration(1000)
            .attr("d", d3.area()
                //.x((d, i) => { let ld = new Date(d.date); ld.setDate(ld.getDate() + 1); return xScale(ld) })
                .x((d) => { return xScaleTime(d3.timeParse("%Y-%m-%d")(d.date)) })
                .y0(function (d) { return yScale(d.longterm) })
                .y1(function (d) { return yScale(min) })
            )

        // react
        svg.selectAll(".bar")
            .transition()
            .duration(1000)
            .attr("x", d => { return xScaleBand(d3.timeParse("%Y-%m-%d")(d.date)) })
            .attr("width", () => { return xScaleBand.bandwidth() });
        svg.selectAll(".bar2")
            .transition()
            .duration(1000)
            .attr("x", d => { return xScaleBand(d3.timeParse("%Y-%m-%d")(d.date)) })
            .attr("width", () => { return xScaleBand.bandwidth() });
    }

    return (
        <div className="stagearea grid p-1">
            <Stack spacing={1}>

                <Item>
                    <DatePicker
                        title="year"
                        value={fromdjs}
                        callback={handleSelector}
                        view={["year"]}
                        format="YYYY"
                    />
                </Item>

            </Stack>


            <div id="svgchart">
                <svg ref={svgRef} id="svg_chart" className="d3chart"></svg>
            </div>

            <Grid container flexDirection={"row"}>

                <Grid item className="p-2" flexGrow={1}>
                    <InfoButton
                        de={""}
                        it={""}
                        en={""}
                    />
                </Grid>

                <Grid item>
                    <GraphicButton object="svg_chart" filename={t('temperature_mids')} />
                </Grid>

                <Grid item className="p-2">
                    <ExcelButton callback={downloadExcel} />
                </Grid>

            </Grid>
        </div>
    );

}
